import { Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-circular-button',
    templateUrl: './circular-button.component.html',
    styleUrls: ['./circular-button.component.scss']
})
export class CircularButtonComponent implements OnInit, OnChanges {

    @HostBinding('class') @Input() size: 'small' | 'regular' | 'large' = 'regular';
    @HostBinding('class') @Input() type: 'primary' | 'secondary' | 'simple' | 'warning' | 'danger' = 'primary';

    @Input() icon: string;
    @Input() pack = 'material-icons';
    @Output() clicked = new EventEmitter<any>();

    _classes = '';

    @HostBinding('class') get classes() {
        return this._classes;
    }

    @HostListener('click', ['$event.target'])
    onBatchClick() {
        this.clicked.emit();
    }

    ngOnInit(): void {
        this._classes = `${this.size} ${this.type}`;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.size || changes.type) {
            this._classes = `${this.size} ${this.type}`;
        }
    }


}
